import {AxiosError} from "axios"

import sentry from "../../../sentry"
import getCodeFromError from "../../helpers/getCodeFromError"
import getDataFromError from "../../helpers/getDataFromError"
import getMessageFromErrorCode from "../../helpers/getMessageFromErrorCode"
import getTraceIdFromError from "../../helpers/getTraceIdFromError"
import {logErrorToIntercom} from "./logErrorToIntercom"

export default (err: AxiosError): PBError => {
  sentry.captureException(err)
  const e = err as unknown as PBError
  e.errorCode = getCodeFromError(err)
  e.message = getMessageFromErrorCode(e.errorCode, e)
  e.traceId = getTraceIdFromError(err)
  e.errorData = getDataFromError(err, e.traceId, e.errorCode)

  try {
    logErrorToIntercom({
      errorCode: e.errorCode,
      errorData: e.errorData,
      traceId: e.traceId,
      operationName: undefined
    })
  } catch (error) {
    /* no-op */
  }

  throw e
}
